<template>
    <div class='base-access'>
      <ly-table
      :getTableData="getTableData"
      :tableHeader="tableHeader"
      ref="lyTable"
      class="ly-card"
    >
      <template v-slot:effectiveTime="row">
        {{dealDate(row)}}
      </template>
      <template v-slot:action="row">
        <el-button @click="editRow(row)" type="primary" size="mini">编辑</el-button>
      </template>
    </ly-table>
     <el-dialog
      title="编辑门禁有效期"
      :visible.sync="dialogVisible"
      width="500px"
      class="edit-dialog"
    >
      <div>所属学期： {{termData.term_label}}</div>
      <div class='dialog-flex'>
        <div class="title">有效时间：</div>
        <div class="content flex-1">
          <el-date-picker
            v-model="date"
            type="daterange"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="MM-dd"
          ></el-date-picker>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveAccess">保存</el-button>
      </span>
     </el-dialog>
    </div>
</template>

<script>
import { Dialog, DatePicker } from 'element-ui';
import LyTable from '@/components/LyTable';
// import LyForm from '@/components/LyForm';
import { accessTable } from '@/utils/tableHeader';
import { base } from '@/api';

export default {
  name: 'access',
  components: {
    LyTable,
    // LyForm,
    ElDialog: Dialog,
    ElDatePicker: DatePicker

  },
  data() {
    return {
      tableHeader: accessTable,
      getTableData: base.accessControl,
      dialogVisible: false,
      date: '',
      termData: {
        term_label: '',
        term: ''
      }
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      this.search();
    },
    search() {
      this.$refs.lyTable.setData();
    },
    saveAccess() {
      if (!this.date) {
        this.$message.warning('有效时间不能为空');
        return;
      }
      base.saveAccess({
        params: {
          start_time: this.date[0],
          end_time: this.date[1],
          term: this.termData.term
        }
      }).then(res => {
        if (res) {
          this.$store.dispatch('msg/showMsg', res.msg || '修改成功');
          this.dialogVisible = false;
          this.search();
        }
      });
    },
    editRow(rowData) {
      // this.defaultFormItem = { ...rowData };
      this.termData.term = rowData.term;
      this.termData.term_label = rowData.term_label;
      this.date = [rowData.start_time, rowData.end_time];
      this.dialogVisible = true;
    },
    dealDate(item) {
      const s_month = new Date(item.start_time).getMonth() + 1;
      const s_day = new Date(item.start_time).getDate();
      const e_month = new Date(item.end_time).getMonth() + 1;
      const e_day = new Date(item.end_time).getDate();
      return `${s_month}月${s_day}日-${e_month}月${e_day}日`;
    }
  }
};
</script>

<style lang="less">
.base-access{
  .dialog-flex{
    display: flex;
    align-items: center;
    margin-top:16px;

  .title {
    margin-right: 20px;
  }
  }

}
</style>
